module.exports = __webpack_public_path__ + "img/credential-text-digital-marketing.908478bff5e6fb2adf561bb15241bd2b.svg";